import {
  Component,
  EventEmitter,
  OnDestroy,
  OnInit,
  Output,
} from '@angular/core';
import {
  IconoirHalfMoon,
  IconoirHelpCircle,
  IconoirLogOut,
  IconoirMoreHoriz,
  IconoirSettings,
  IconoirSunLight,
  IconoirUser,
} from '@ey-xd/motif-icon';
import {
  MotifAvatarModule,
  MotifDropdownModule,
  MotifHeaderModule,
  MotifIconModule,
  MotifThemeModule,
  MotifVerticalNavigationModule,
  Placement,
  ScrollStrategy,
} from '@ey-xd/ng-motif';
import { IProfileType } from 'app/core/service/auth/profile';
import { Subject, Subscription, take, takeUntil } from 'rxjs';
import { HeaderTitleService } from 'services/header-title.service';
import { AuthenticationService } from '../../service/auth/authentication.service';
import { FeedbackService } from 'app/core/service/feedback/feedback.service';
import { HttpErrorResponse } from '@angular/common/http';
import { ModalExportSurverys } from '../survey-export-modal/survey-export-modal.component';
import {
  MotifButtonModule,
  MotifModal,
  MotifModalModule,
} from '@ey-xd/ng-motif';

@Component({
  selector: 'app-header',
  standalone: true,
  imports: [
    MotifIconModule,
    MotifHeaderModule,
    MotifDropdownModule,
    MotifAvatarModule,
    MotifVerticalNavigationModule,
    MotifThemeModule,
    MotifModalModule,
    MotifButtonModule,
  ],
  templateUrl: './header.component.html',
  styleUrl: './header.component.scss',
})
export class HeaderComponent implements OnInit, OnDestroy {
  IconoirSunLight = IconoirSunLight;
  IconoirHalfMoon = IconoirHalfMoon;
  IconoirUser = IconoirUser;
  IconoirMoreHoriz = IconoirMoreHoriz;
  IconoirLogOut = IconoirLogOut;
  IconoirSettings = IconoirSettings;
  IconoirHelpCircle = IconoirHelpCircle;

  Placement = Placement;
  ScrollStrategy = ScrollStrategy;

  ModalExportSurverys = ModalExportSurverys;
  //
  @Output() changeThemeEvent = new EventEmitter();
  @Output() toggleMenuEvent = new EventEmitter();

  menuIconSize: string = String(36);

  theme: string = 'dark';
  showMenu: boolean = false;

  title: string = '';
  profile?: IProfileType;

  private _destroy$ = new Subject<void>();

  constructor(
    private authenticationService: AuthenticationService,
    private headerTitleService: HeaderTitleService,
    private feedbackService: FeedbackService,
    public modal: MotifModal
  ) {}

  isAdmin: boolean = false;
  private titleSubscription?: Subscription;

  ngOnInit(): void {
    this.headerTitleSubscribe();
    this.profileSubscribe();
    this.getMeRole();
  }

  private headerTitleSubscribe(): void {
    this.headerTitleService.headerTitle$
      .pipe(takeUntil(this._destroy$))
      .subscribe((title: string | undefined) => {
        this.title = title || 'CIT Agent';
      });
  }

  private profileSubscribe(): void {
    this.authenticationService
      .isLoggedIn()
      .pipe(takeUntil(this._destroy$))
      .subscribe((loggedIn: boolean) => {
        if (loggedIn) {
          this.authenticationService
            .getProfile()
            .pipe(take(1))
            .subscribe((profile: IProfileType) => {
              // TODO fix profile discrepancy, see console.log output:
              // console.log(
              //   'profile',
              //   profile,
              //   this.authenticationService.profile
              // );
              this.profile = profile;
            });
        }
      });
  }

  ngOnDestroy(): void {
    this._destroy$.next();
    this._destroy$.complete();
  }

  toggleMenu(): void {
    this.showMenu = !this.showMenu;
    this.toggleMenuEvent.emit();
  }

  toggleTheme() {
    this.changeThemeEvent.emit();
  }

  logout() {
    this.authenticationService.logout();
  }

  openModal() {
    const modalRef = this.modal.open(ModalExportSurverys);
    modalRef.afterClosed().subscribe((result) => {
      console.log(`Dialog result: ${result}`);
    });
  }

  getMeRole() {
    this.feedbackService.getMeRole('').subscribe({
      next: (data: any) => {
        console.log('data role');
        console.log(data.role);
        if (data.role === 1) {
          this.isAdmin = true;
        } else {
          this.isAdmin = false;
        }
      },
      error: (error: HttpErrorResponse) => {},
    });
  }

  // exportSurvey() {
  //   this.feedbackService
  //     .exportSurvey("")
  //     .subscribe({
  //       next: (data: any) => {
  //         if (data.role === 1) {
  //           this.isAdmin = true;
  //         } else {
  //           this.isAdmin = false;
  //         }
  //       },
  //       error: (error: HttpErrorResponse) => {

  //       },
  //     });
  // }
}
